import { useState, useEffect, useContext } from "react";
import i18n from "i18next";
import User from "../../API/APIServices/User";
import { useNavigate } from "react-router-dom";
import UserApi from "../../API/APIServices/User";
import UserCredential from "../../API/APIServices/UserCredential";
import Company from "../../API/APIServices/Company";
import MyContext from "../MyContext";
import DBBackup from "../../API/APIServices/DBBackup";
import Swal from "sweetalert2";

const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

function MainButton(props) {
  const {
    setLoginSuccess,
    UserDetails,
    setIsAuthenticated,
    setUserDetails,
    companyData,
    Offescpback,
  } = useContext(MyContext);
  const fetchUser = async () => {
    if (UserDetails) {
      ;
      const storedArrayString = localStorage.getItem("loginAccountUserData");
      var loginUser;
      if (storedArrayString) {
        loginUser = JSON.parse(storedArrayString);
      }

      const response = await UserCredential.CurrentUser();
      const id = response.data.result?.userId;
      if (id && id != 0) {
        const userData = await UserCredential.getUserCredentialById(id);
        if (userData) {
          setUserDetails(userData);
        }
      }
    }
  };
  useEffect(() => {
    if (UserDetails) {
      fetchUser();
    }
  }, []);
  const [isHoverdReset, setisHoverdReset] = useState(false);
  const { PageName } = props;
  //*********************{Button Script}*********************//
  var modalOpen = props.modelOpen;
  const [isHovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };

  const [isBackButton, setisBackButton] = useState(true);
  const [isAdminName, setisAdminName] = useState(true);

  const [isLogoutButton, setisLogoutButton] = useState(true);
  const [isResetButton, setisResetButton] = useState(true);

  const [SaveButtonName, setSaveButtonName] = useState("Save/F10");
  const [isF4ListenForSave, setIsF4ListenForSave] = useState(false);

  useEffect(() => {
    if (props.isBackButton == false) {
      setisBackButton(false);
    } else {
      setisBackButton(true);
    }

    if (props.isLogoutButton == false) {
      setisLogoutButton(false);
    } else {
      setisLogoutButton(true);
    }

    if (props.isResetButton == false) {
      setisResetButton(false);
    } else {
      setisResetButton(true);
    }
    if (props.isAdminName == false) {
      setisAdminName(false);
    } else {
      setisAdminName(true);
    }
    if (props.SaveButtonName) {
      setSaveButtonName(props.SaveButtonName);
    } else {
      setSaveButtonName("Save/F10");
    }

    if (props.isF4ListenForSave !== undefined) {
      setIsF4ListenForSave(props.isF4ListenForSave);
    } else {
      setIsF4ListenForSave(false);
    }
  }, []);

  const handleResetHover = () => {
    setisHoverdReset(!isHoverdReset);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const [isHoveredPay, setHoveredPay] = useState(false);
  const handleMouseEnterPay = () => {
    setHoveredPay(true);
  };
  const handleMouseLeavePay = () => {
    setHoveredPay(false);
  };

  const [isHovered1, setHovered1] = useState(false);
  const handleMouseEnter1 = () => {
    setHovered1(true);
  };
  const handleMouseLeave1 = () => {
    setHovered1(false);
  };
  const [isHovered2, setHovered2] = useState(false);
  const handleMouseEnter2 = () => {
    setHovered2(true);
  };
  const handleMouseLeave2 = () => {
    setHovered2(false);
  };
  const [isHovered3, setHovered3] = useState(false);
  const handleMouseEnter3 = () => {
    setHovered3(true);
  };
  const handleMouseLeave3 = () => {
    setHovered3(false);
  };

  const [isHovered4, setHovered4] = useState(false);
  const handleMouseEnter4 = () => {
    setHovered4(true);
  };
  const handleMouseLeave4 = () => {
    setHovered4(false);
  };

  const [isHovered5, setHovered5] = useState(false);
  const handleMouseEnter5 = () => {
    setHovered5(true);
  };
  const handleMouseLeave5 = () => {
    setHovered5(false);
  };
  const [isHovered6, setHovered6] = useState(false);
  const handleMouseEnter6 = () => {
    setHovered6(true);
  };
  const handleMouseLeave6 = () => {
    setHovered6(false);
  };

  const [isHovered7, setHovered7] = useState(false);
  const handleMouseEnter7 = () => {
    setHovered7(true);
  };
  const handleMouseLeave7 = () => {
    setHovered7(false);
  };

  const [isHovered8, setHovered8] = useState(false);
  const handleMouseEnter8 = () => {
    setHovered8(true);
  };
  const handleMouseLeave8 = () => {
    setHovered8(false);
  };
  const [isHoveredExcel, setHoveredExcel] = useState(false);
  const handleMouseEnterExcel = () => {
    setHoveredExcel(true);
  };
  const handleMouseLeaveExcel = () => {
    setHoveredExcel(false);
  };

  const [isHoveredSubmit, setHoveredSubmit] = useState(false);
  const handleMouseEnterSubmit = () => {
    setHoveredSubmit(true);
  };
  const handleMouseLeaveSubmit = () => {
    setHoveredSubmit(false);
  };

  const [isHovered9, setHovered9] = useState(false);
  const handleMouseEnter9 = () => {
    setHovered9(true);
  };
  const handleMouseLeave9 = () => {
    setHovered9(false);
  };
  const [isHovered10, setHovered10] = useState(false);
  const handleMouseEnter10 = () => {
    setHovered10(true);
  };
  const handleMouseLeave10 = () => {
    setHovered10(false);
  };

  const handleBack = () => {
    const url = window.location.pathname;

    if (url.toLocaleLowerCase().includes("/saleinvoice")) {
      props.setSliderCallBack();
      return;
    }
    if (Boolean(modalOpen) === true) {
      props.setSliderCallBack(false);
    } else {
      window.history.back();
    }

    // if (Boolean(props.modelOpen) === true) {
    //   props.setSliderCallBack(false);
    //  }
    //  else {
    //  window.history.back();
    // }
  };
  const handlePrint = () => {
    
    window.print();
  };
  // const [, setModalOpen] = useState('');
  // const [, setPartyDetailModal] = useState('');
  // const showModal = () => {
  //     setModalOpen(true);
  // };
  // const openPartyModal = () => {
  //     setPartyDetailModal(true);
  // };
  // const hideModal = () => {
  //     setModalOpen(false);
  // };

  const changeLanguage = (lng) => {
    console.log("Hello");
    i18n.changeLanguage(lng);
  };

  const [isEnlishLanguage] = useState(props.isEnlishLanguage);
  const [isHindiLanguage] = useState(props.isHindiLanguage);
  const [isBtnSetting] = useState(props.isBtnSetting);
  const [isBtnSaleInvoiceSetting] = useState(props.isBtnSaleInvoiceSetting);
  const [isBtnOrder] = useState(props.isBtnOrder);
  const [isBtnChallan] = useState(props.isBtnChallan);
  const [isBtnPatient] = useState(props.isBtnPatient);
  const [isBtnSearch] = useState(props.isBtnSearch);
  const [SavePay] = useState(props.SavePay);
  const [isSubmit] = useState(props.isSubmit);
  const [PrintIcon] = useState(props.PrintIcon);
  const { ShowReset } = props;
  const [isExportFile] = useState(props.isExportFile);
  const [isShowDBBackup] = useState(props.DBBackup);
  console.log(isBtnOrder);
  console.log("isBtnChallan", isBtnChallan);

  const [saveButtonHide, setSaveButtonHide] = useState(false);
  useEffect(() => {
    if (props.saveButtonHide && props.saveButtonHide == true) {
      setSaveButtonHide(true);
    } else {
      setSaveButtonHide(false);
    }
  }, [props]);

  const [loginValues] = useState({
    id: 1,
    code: "C0001",
    UserName: "admin",
    Password: "admin",
  });
  const login = () => {
    UserApi.login(loginValues);
  };

  const SaveBtn = () => {
    props.SaveButton();
    // if (props.setSliderCallBack(false) === true) {
    //     props.setSliderCallBack(false);
    // }
  };

  const ResetSettings = () => {
    props.ResetSettings();
    // if (props.setSliderCallBack(false) === true) {
    //     props.setSliderCallBack(false);
    // }
  };
  const [logout] = useState(true); //props.loginbtn
  const navigate = useNavigate();

  const logoutpage = async () => {
    if (window.confirm("Are you sure? Your want to LogOut")) {
      await User.Logout();
      setLoginSuccess(false);
      localStorage.clear();
      navigate("/loginpanel");
      window.location.reload();
      localStorage.removeItem("isAuthenticated");
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (saveButtonHide) return;
      if (event.key === "F10") { 
        props.SaveButton();
      }
    };

    const handleKeyPressF4 = (event) => {
      if (saveButtonHide) return;
      if (event.key === "F4") {
        SaveBtn();
        console.log(
          "saveClick F4",
          props.saveclickItemMaster
            ? props.saveclickItemMaster
            : "not item Master"
        );
      }
    };

    if (isF4ListenForSave) {
      window.addEventListener("keydown", handleKeyPressF4);
    } else {
      window.addEventListener("keydown", handleKeyPress);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("keydown", handleKeyPressF4);
    };
  }, [isF4ListenForSave, props]);

  const handleSearchClick = () => {
    props.handleSearchClick();
  };

  const handleExportFileClick = () => {
    props.handleExportFileClick();
  };

  useEffect(() => {
    // Add the animation class to labels when component mounts
    const labels = document.querySelectorAll(".focus-label");
    labels.forEach((label) => {
      label.classList.add("animate-focus");
    });

    // Clean up function to remove the animation class
    return () => {
      labels.forEach((label) => {
        label.classList.remove("animate-focus");
      });
    };
  }, []); //

  const [firmName, setFirmName] = useState();
  const [userName, setUserName] = useState();

  const [isAllowExportExcel, setIsAllowExportExcel] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const arrayString = localStorage.getItem("loginUser");
      const arrayToStore = JSON.parse(arrayString);
      setUserName(arrayToStore.userName);
      if (companyData || companyData == "") {
        const data = await Company.GetCompanyById(arrayToStore.compId);
        setFirmName(data.name);
      } else {
        setFirmName(companyData?.name);
      }
      if (arrayToStore.userId && arrayToStore.userId != 0) {
        const userData = await UserCredential.getUserCredentialById(
          arrayToStore.userId
        );
        setIsAllowExportExcel(userData ? userData?.canExportReport : "false");
      }
    };

    fetchData();
  }, []);

  const handleDBBackupBtn = async () => {
    // const data = await `${WebApiUrl}/api/BackupDB/DatabaseBackup`
    const data = await DBBackup.databaseBackup();
    if (data) {
      alert("Database Backup Completed Successfully");
    }
  };

  const handleImageBackup = async () => {
    const data = await DBBackup.imageBackup();
    if (data) {
      alert("Image Backup Completed Successfully");
    }
  };

  return (
    <div className="panel-head-button">
      <div className="navbar-right">
        {isShowDBBackup && (
          <div className="button-m5">
            <button
              className={`save-button-main ${isHovered9 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter9}
              onMouseLeave={handleMouseLeave9}
              onClick={handleDBBackupBtn}
            >
              DB Backup
              {/* <i id="" className="fa-solid fa-rotate im-icon-2" ></i> */}
              {isHovered9 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Database Backup
                </div>
              )}
            </button>
          </div>
        )}
        {isShowDBBackup && (
          <div className="button-m5">
            <button
              className={`save-button-main ${isHovered9 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter10}
              onMouseLeave={handleMouseLeave10}
              onClick={handleImageBackup}
            >
              Image Backup
              {/* <i id="" className="fa-solid fa-rotate im-icon-2" ></i> */}
              {isHovered10 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Image Backup
                </div>
              )}
            </button>
          </div>
        )}

        {PrintIcon && (
          <div className="Tablebutton5">
            <button
              className={`save-button-main-small ${
                isHovered4 ? "hovered" : ""
              }`} //onClick={props.handleExportToPDF}
              onMouseEnter={handleMouseEnter4}
              onMouseLeave={handleMouseLeave4}
              onClick={handlePrint}
            >
              <i id="step-2" class="fa-solid fa-print IconFontS1"></i>
              {isHovered4 && (
                <div className="hoverSmallButton">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  Print/F9
                </div>
              )}
            </button>
          </div>
        )}

        {ShowReset && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={ResetSettings}
              style={{ width: "100%" }}
              className={`save-button-main-save ${isHovered ? "hovered" : ""}`}
              onMouseEnter={handleResetHover}
              onMouseLeave={handleResetHover}
            >
              Reset Settings
              {isHoverdReset && (
                <div className="hover-textSave">Reset Settings</div>
              )}
            </button>
          </div>
        )}

        {isBtnPatient && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={SaveBtn}
              className={`save-button-main-save ${isHovered7 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter7}
              onMouseLeave={handleMouseLeave7}
            >
              New Patient
              {/* <i id="step-2" className="fa-regular fa-floppy-disk im-icon-white"></i> */}
              {/* <i id="step-2" className="fa-solid fa-file-export im-icon-white"></i> */}
              {isHovered7 && (
                <div className="hover-textSave">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  New Patient
                </div>
              )}
            </button>
          </div>
        )}

        {isBtnSearch && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={handleSearchClick}
              className={`save-button-main-save ${isHovered8 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter8}
              onMouseLeave={handleMouseLeave8}
            >
              Search
              {/* <i id="step-2" className="fa-regular fa-floppy-disk im-icon-white"></i> */}
              {/* <i id="step-2" className="fa-solid fa-file-export im-icon-white"></i> */}
              {isHovered8 && (
                <div className="hover-textSave">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  Search
                </div>
              )}
            </button>
          </div>
        )}
        {isExportFile && isAllowExportExcel && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={handleExportFileClick}
              className={`save-button-main-save ${isHovered8 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnterExcel}
              onMouseLeave={handleMouseLeaveExcel}
            >
              Export File
              {/* <i id="step-2" className="fa-regular fa-floppy-disk im-icon-white"></i> */}
              {/* <i id="step-2" className="fa-solid fa-file-export im-icon-white"></i> */}
              {isHoveredExcel && (
                <div className="hover-textSave">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  Export to Excel
                </div>
              )}
            </button>
          </div>
        )}

        {saveButtonHide ? (
          ""
        ) : (PageName === "Modifycompany" && UserDetails?.canEditComp) ||
          (PageName === "Masters" && UserDetails?.canModifyMaster) ||
          PageName == null ||
          PageName === "" ||
          PageName == undefined ? ( // Check if PageName is null, undefined, or empty
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={SaveBtn}
              className={`save-button-main-save ${isHovered ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {SaveButtonName}
              <i
                id="step-2"
                className="fa-regular fa-floppy-disk im-icon-white"
              ></i>
              {isHovered && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  {SaveButtonName}
                </div>
              )}
            </button>
          </div>
        ) : null}

        {SavePay && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={SaveBtn}
              className={`save-button-main-save ${
                isHoveredPay ? "hovered" : ""
              }`}
              onMouseEnter={handleMouseEnterPay}
              onMouseLeave={handleMouseLeavePay}
            >
              Save & Pay
              <i
                id="step-2"
                className="fa-regular fa-floppy-disk im-icon-white"
              ></i>
              {/* <i id="step-2" className="fa-solid fa-file-export im-icon-white"></i> */}
              {isHoveredPay && (
                <div className="hover-textSave">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  Save & Pay
                </div>
              )}
            </button>
          </div>
        )}

        {isSubmit && (
          <div className="button-m5">
            <button
              id="SaveBtnMain"
              onClick={SaveBtn}
              className={`save-button-main-save ${
                isHoveredSubmit ? "hovered" : ""
              }`}
              onMouseEnter={handleMouseEnterSubmit}
              onMouseLeave={handleMouseLeaveSubmit}
            >
              Submit
              <i
                id="step-2"
                className="fa-regular fa-floppy-disk im-icon-white"
              ></i>
              {/* <i id="step-2" className="fa-solid fa-file-export im-icon-white"></i> */}
              {isHoveredSubmit && (
                <div className="hover-textSave">
                  <i class="fa-solid fa-sort-up ItemIconHover"></i>
                  Submit
                </div>
              )}
            </button>
          </div>
        )}

        {isResetButton && (
          <div className="button-m5">
            <button
              className={`save-button-main ${isHovered1 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter1}
              onMouseLeave={handleMouseLeave1}
              onClick={() => window.location.reload()}
            >
              Reset
              <i id="" className="fa-solid fa-rotate im-icon-2"></i>
              {isHovered1 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Reset/F8
                </div>
              )}
            </button>
          </div>
        )}

        {isBtnOrder || props.isBtnOrder && (
          <div className="button-m5">
            <button
              onClick={props.showModal1}
              className={`save-button-main ${isHovered5 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter5}
              onMouseLeave={handleMouseLeave5}
            >
              Order
              <i id="" className="fa-solid fa-rotate im-icon-2"></i>
              {isHovered5 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Order
                </div>
              )}
            </button>
          </div>
        )}
        {isBtnChallan || props.isBtnChallan  && (
          <div className="button-m5">
            <button
              onClick={props.showModal2}
              className={`save-button-main ${isHovered6 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter6}
              onMouseLeave={handleMouseLeave6}
            >
              Challan
              <i id="step-2" className="fa-solid fa-rotate im-icon-2"></i>
              {isHovered6 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Challan
                </div>
              )}
            </button>
          </div>
        )}
        {isEnlishLanguage && (
          <div onClick={() => changeLanguage("en")} className="button-m5">
            <button className="save-button-main">
              Eng
              <i id="step-1" className="fa-solid fa-rotate im-icon-2"></i>
            </button>
          </div>
        )}
        {isHindiLanguage && (
          <div onClick={() => changeLanguage("hin")} className="button-m5">
            <button
              onClick={() => changeLanguage("hin")}
              className="save-button-main"
            >
              Hindi
              <i id="step-4" className="fa-solid fa-rotate im-icon-2"></i>
            </button>
          </div>
        )}
        {isBtnSetting && (
          <div
            onClick={() => {
              props.showModal();
              // ; props.OpenPartyModal();
            }}
            className="button-m5"
          >
            <button
              className={`save-button-main ${isHovered2 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
            >
              Setting
              <i id="step-2" className="fa-solid fa-gear im-icon-2"></i>
              {isHovered2 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Setting/F9
                </div>
              )}
            </button>
          </div>
        )}
        {isBtnSaleInvoiceSetting && (
          <div
            onClick={() => {
              props.OpenPartyModal();
            }}
            className="button-m5"
          >
            <button
              className={`save-button-main ${isHovered2 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
            >
              Setting
              <i id="step-2" className="fa-solid fa-gear im-icon-2"></i>
              {isHovered2 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Setting/F9
                </div>
              )}
            </button>
          </div>
        )}
        {isBackButton && (
          <div onClick={handleBack} className="button-m5">
            <button
              className={`save-button-main ${isHovered3 ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter3}
              onMouseLeave={handleMouseLeave3}
            >
              <i
                id="step-2"
                className="fa-solid fa-arrow-left-long im-IconRight"
                onClick={handleBack}
              ></i>
              Back/ESC
              {isHovered3 && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Back/ESC
                </div>
              )}
            </button>
          </div>
        )}
        {/* <div className="button-m5">
                    <button onClick={login}>login</button>
                </div> */}
        {isLogoutButton && (
          <div className="button-m5">
            {logout && (
              <button
                onClick={logoutpage}
                // style={{ marginLeft: "10px" }}
                className="save-button-main button-m5"
              >
                Logout
              </button>
            )}
          </div>
        )}
        {isAdminName && (
          <div className="loggedInDataDiv">
            <label className="loggedInDataLabel">Hi,{userName}</label>
            <label className="loggedInDataLabel">{firmName}</label>
          </div>
        )}
      </div>
    </div>
  );
}

export default MainButton;
